import { type ReactNode } from 'react';

interface IconButtonProps {
    cssClasses?: string;
    icon: ReactNode;
    children?: ReactNode;
    onClick?: () => void;
    ariaLabel?: string;
}

const IconButton = ({ cssClasses = "", icon, children, onClick, ariaLabel }: IconButtonProps) => {
    const hasText = Boolean(children);

    return (
        <button type="button" className={`btn btn--icon btn--icon-only ${cssClasses}`} onClick={onClick} aria-label={ariaLabel ?? (hasText ? undefined : 'Icon button')}>
            <span className="btn__icon" aria-hidden={!!children}>
                {icon}
            </span>

            {children && <span className="btn__txt">{children}</span>}
        </button>
    );
};

export default IconButton;